import type { EditorAPI } from '@/editorAPI';
import createCalendarWidget from './createCalendarWidget';

export default ({ editorAPI }: { editorAPI: EditorAPI }) =>
  createCalendarWidget({
    editorAPI,
  });
